import axiosServices from "../utils/axios";

import type { PilotTrackerMovement } from "../utils/types/pilotTracker";

export const fetchPilotTrackerMovements = async (): Promise<{ data: PilotTrackerMovement[], lastSyncedAt: string }> => {
  const response = await axiosServices.get(`/pilot-tracker`);
  const { data, lastSyncedAt } = response.data;
  return { data, lastSyncedAt };
};
